// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_MasterBalanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/master_balance/{provider}
 *
 * Passthrough payload from upstream payment provider's getBalance().
 * The shape is owned by the provider SDK (ASAAS, Stripe, etc.).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_MasterBalanceResponseDados = unknown[];

export type SubaccountsFranchises_MasterBalanceResponse = ApiResponse<SubaccountsFranchises_MasterBalanceResponseDados>;

registerResponseContract('SubaccountsFranchises_MasterBalanceResponse', {})
